
const LAST_UPDATED = "26 December 2025";

export default function Privacy() {
    return (
        <main className="min-h-screen bg-pink-50">
            <section className="max-w-3xl mx-auto py-12 px-4 sm:px-6 lg:px-8">
                <h1 className="text-3xl font-bold text-slate-900 mb-2">
                    Privacy Policy
                </h1>
                <p className="text-sm text-slate-500 mb-8">
                    Last updated: {LAST_UPDATED}
                </p>

                <div className="space-y-6 text-slate-800 leading-relaxed">
                    <p>
                        UnicorNation (&quot;we&quot;, &quot;us&quot;, &quot;our&quot;) is based in Victoria,
                        Australia. We operate a website that helps users discover queer
                        parties, events, and related experiences, as well as links to
                        external merchandise and resources.
                    </p>

                    <p>
                        We respect your privacy and are committed to protecting your
                        personal information. This policy explains how we collect, use,
                        store, and handle your data in line with the Australian Privacy Act
                        1988 and the Australian Consumer Law.
                    </p>

                    <h2 className="text-xl font-semibold mt-6">1. Information We Collect</h2>

                    <h3 className="text-lg font-semibold mt-4">1.1 Information you provide</h3>
                    <ul className="list-disc list-inside space-y-1">
                        <li>Email address (if you subscribe to newsletters or event reminders)</li>
                        <li>Any information you provide through contact forms or feedback</li>
                    </ul>

                    <h3 className="text-lg font-semibold mt-4">1.2 Information we collect automatically</h3>
                    <ul className="list-disc list-inside space-y-1">
                        <li>Website usage analytics (via Google Analytics)</li>
                        <li>Device and browser information</li>
                        <li>Pages visited and general interaction data</li>
                        <li>Cookies and similar tracking technologies</li>
                    </ul>

                    <h3 className="text-lg font-semibold mt-4">1.3 Information from third parties</h3>
                    <p>
                        We do not currently collect personal information directly from third
                        parties for ordinary use of the site.
                    </p>

                    <h2 className="text-xl font-semibold mt-6">2. How We Use Your Information</h2>
                    <p>We use your information to:</p>
                    <ul className="list-disc list-inside space-y-1">
                        <li>Send newsletters or event reminders you&apos;ve subscribed to</li>
                        <li>Improve and optimise website performance and content</li>
                        <li>Understand how visitors use UnicorNation</li>
                        <li>Maintain security and prevent abuse of the service</li>
                    </ul>
                    <p>We will never sell your personal information.</p>

                    <h2 className="text-xl font-semibold mt-6">3. Email Communications</h2>
                    <p>
                        If you subscribe to newsletters or event reminders, you consent to
                        receive those communications from us.
                    </p>
                    <ul className="list-disc list-inside space-y-1">
                        <li>You can unsubscribe at any time using the link in our emails.</li>
                        <li>Emails may be delivered through third-party email providers.</li>
                        <li>We comply with the Australian Spam Act 2003.</li>
                    </ul>

                    <h2 className="text-xl font-semibold mt-6">4. Cookies and Analytics</h2>
                    <p>
                        We use cookies and similar technologies to help the site function
                        and to understand how it is used.
                    </p>
                    <ul className="list-disc list-inside space-y-1">
                        <li>We use Google Analytics to collect aggregated usage data.</li>
                        <li>
                            You can disable cookies in your browser settings, but some features
                            of the site may not work as intended.
                        </li>
                    </ul>

                    <h2 className="text-xl font-semibold mt-6">5. Third-Party Links</h2>
                    <p>
                        UnicorNation includes links to external websites, including event
                        pages, ticketing platforms, merchandise stores, and health and safety
                        resources.
                    </p>
                    <p>
                        We are not responsible for the content, privacy practices, or
                        security of these external sites. We encourage you to review the
                        privacy policies of any third-party services you use.
                    </p>

                    <h2 className="text-xl font-semibold mt-6">6. Data Storage and Security</h2>
                    <p>
                        We use cloud-based infrastructure (including Supabase and related
                        services) to store and process any collected information. This may
                        involve hosting data outside Australia.
                    </p>
                    <p>
                        By using UnicorNation, you consent to the transfer and storage of
                        your information outside Australia.
                    </p>
                    <p>
                        We take reasonable steps to protect your information from misuse,
                        interference, loss, and unauthorised access, modification or
                        disclosure. However, no method of transmission or storage is 100%
                        secure.
                    </p>

                    <h2 className="text-xl font-semibold mt-6">7. Children&apos;s Privacy</h2>
                    <p>
                        UnicorNation is intended for adults (18+). We do not knowingly
                        collect personal information from children. If you believe a child
                        has provided us with personal information, please contact us and we
                        will take steps to remove it.
                    </p>

                    <h2 className="text-xl font-semibold mt-6">8. Changes to This Policy</h2>
                    <p>
                        We may update this Privacy Policy from time to time. The updated
                        version will be posted on this page with a revised &quot;Last
                        updated&quot; date. Your continued use of the site after any changes
                        means you accept the updated policy.
                    </p>

                    <h2 className="text-xl font-semibold mt-6">9. Contact Us</h2>
                    <p>
                        If you have any questions about this Privacy Policy or how we handle
                        your data, please contact us at:
                    </p>
                    <p className="font-medium">
                        contact@unicornation.com.au
                    </p>
                </div>
            </section>
        </main>
    );
}
